import React, { useState , useEffect} from 'react';
import { Button, Modal, ModalBody, ModalHeader, UncontrolledTooltip } from 'reactstrap';
import Mongo_Db_Query from '../../../pages/Mongo_Db/Mongo_Db_Query';
import Mongo_JsonViewer_Modal from './Mongo_JsonViewer_Modal';



const Mongo_DB_Query_modal = ({mongo_query ,  database_id}) => {

    const [mongo_query_input, setmongo_query_input] = useState(mongo_query)

    useEffect(() => {
     setmongo_query_input(mongo_query)
    }, [mongo_query])
    

    const [modal_standard, setmodal_standard] = useState(false);
        function tog_standard() {
            setmodal_standard(!modal_standard);
        }

  return (
    <>
        <Button color="primary" id="mongodb" onClick={() => tog_standard()} style={{borderRadius:'30px'}}>
                  <i class="ri-leaf-fill"></i></Button>
                  <UncontrolledTooltip
                                      placement="left"
                                      target="mongodb"
                                      className="leftmore"
                                      id="mongodb"
                                    >
                                      MongodB
                                    </UncontrolledTooltip>
                  {/* <i class="ri-leaf-fill"></i><i class="ri-database-2-line"></i></Button> */}
        {/* Default Modal */}
            <Modal id="myModal"
            size="lg"
                isOpen={modal_standard}
                toggle={() => {
                    tog_standard();
                }}
            >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }}>

                    Mongo DB Query
                </ModalHeader>
                <ModalBody>
                   <Mongo_Db_Query mongo_query={mongo_query_input} setmongo_query_input={setmongo_query_input} />
                </ModalBody>
                <div className="modal-footer">
                    <Button
                        color="light"
                        onClick={() => {
                            tog_standard();
                        }}
                    >
                        Close
                    </Button>
                    <Mongo_JsonViewer_Modal mongo_query={mongo_query_input} database_id={database_id} />
                </div>
            </Modal>
    </>
  )
}

export default Mongo_DB_Query_modal